export default __webpack_public_path__ + "c314a21d073637b1c0f2cc1879d018bc.svg";